import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {Favourite} from "@/store/favourites";


export class FavouritesApi {
    // Получить список избранного
    static getFavourites(filter: string): Promise<Favourite[]> {
        const http = new CommonHttp()
        return http
            .get(`favorite/list${filter ? `?filter=${filter}` : ''}`)
            .then(data => data.data)
    }
    // Добавить в избранное
    static addFavourites(model: { EntityId: number, Type: number }): Promise<any> {
        const http = new CommonHttp()
        return http
            .post('favorite/add', model)
            .then(data => data.data)
    }
    // Добавить в избранное
    static removeFavourites(model: { EntityId: number, Type: number }): Promise<any> {
        const http = new CommonHttp()
        return http
            .post('favorite/remove', model)
            .then(data => data.data)
    }
}
